import { SYSAction } from "../../../../../../../_ovlclient/src"
import { HookFormValidate_Type } from "../../../../../../../_ovlclient/src/global/hooks"

const HookFormValidate: SYSAction<HookFormValidate_Type> = (value) => {
  switch (value.field.fieldKey) {
    case "msg":
      value.validatorUse("Mandatory")
      break
  }
}

export let hooks = { HookFormValidate }
